import styled from 'styled-components';

export const IconWrapper = styled.div`
  margin-top: 13px;
  display: flex;
  justify-content: center;
  position: relative;
  img {
    width: 154px;
    height: 132px;
  }
  svg {
    position: absolute;
    top: 13px;
    left: 51px;
  }
`;
